import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert, AlertProps } from 'shared/mui/Alert/Alert';
import { Button } from 'shared/mui/Buttons';
import { CloseIconButton } from 'shared/mui/IconButtons';

type Props = {
  onClick: VoidFunction;
  onClose: VoidFunction;
} & AlertProps;

export const ListExportAlert: React.FC<Props> = ({ onClick, onClose, ...props }) => {
  const translate = useTypedTranslate();

  return (
    <Alert
      action={[
        <Button
          color="inherit"
          key="export-button"
          label={translate('app.buttons.export')}
          onClick={onClick}
          size="small"
          variant="text"
        />,
        <CloseIconButton color="inherit" key="close-button" onClose={onClose} />,
      ]}
      severity="warning"
      {...props}
    >
      {translate('app.filter.appliedFilterTooBroad')}.
    </Alert>
  );
};
